module.exports = __webpack_public_path__ + "static/media/sort-down.13b0b274.svg";